var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMasterCardIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 108,
    height: 67,
    viewBox: "0 0 108 67",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MasterCard",
    transform: "translate(0 0.312)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle_1769",
    "data-name": "Rectangle 1769",
    transform: "translate(0 -0.312)",
    fill: "#fff",
    stroke: "#c3c3c3",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 108,
    height: 67,
    rx: 3,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 107,
    height: 66,
    rx: 2.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mastercard_logo",
    transform: "translate(13.214 9.24)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15148",
    "data-name": "Path 15148",
    d: "M46.938,69.89A23.677,23.677,0,1,0,23.256,46.208,23.685,23.685,0,0,0,46.938,69.89Z",
    transform: "translate(-23.256 -22.536)",
    fill: "#e2001a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15149",
    "data-name": "Path 15149",
    d: "M276.032,69.89A23.677,23.677,0,1,0,252.36,46.208,23.685,23.685,0,0,0,276.032,69.89Z",
    transform: "translate(-217.903 -22.536)",
    fill: "#f6a800"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15150",
    "data-name": "Path 15150",
    d: "M258.792,105.209a23.709,23.709,0,0,1-.119-32.345h0l.5.26h0a23.671,23.671,0,0,1-.043,31.739h0l-.336.347Z",
    transform: "translate(-217.903 -65.295)",
    fill: "#eb690a"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15151",
    "data-name": "Path 15151",
    d: "M54.144,140.472h2.068l2.653,6.616,2.371-6.616h2.187v8.815h-1.7v-6.541l-2.274,6.541H58.161l-2.274-6.454v6.454H54.144Z",
    transform: "translate(-49.498 -122.735)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15152",
    "data-name": "Path 15152",
    d: "M165.539,160.97v-6.746h-1.451v6.746Z",
    transform: "translate(-142.907 -134.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_6852",
    "data-name": "Group 6852",
    transform: "translate(29.931 17.857)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_15153",
    "data-name": "Path 15153",
    d: "M229.623,149.959v-8.7H228.1v8.7Z",
    transform: "translate(-227.219 -141.264)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15154",
    "data-name": "Path 15154",
    d: "M222.264,154.224v1.613h3.4v-1.613Z",
    transform: "translate(-222.264 -152.275)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_15155",
    "data-name": "Path 15155",
    d: "M443.243,160.97v-6.746h-1.451v6.746Z",
    transform: "translate(-378.845 -134.418)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15156",
    "data-name": "Path 15156",
    d: "M530.363,151.428v-8.436h-1.451v8.436Z",
    transform: "translate(-452.862 -124.876)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15157",
    "data-name": "Path 15157",
    d: "M311.537,153.978h-1.505v6.746h1.527v-4.462h0a2.053,2.053,0,0,1,1.6-.877h0v-1.451h0c-.357,0-1.581.271-1.624.931h0v-.888Z",
    transform: "translate(-266.901 -134.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15158",
    "data-name": "Path 15158",
    d: "M464.908,153.978h-1.516v6.746h1.538v-4.462h0a2.037,2.037,0,0,1,1.592-.877h0v-1.451h0c-.347,0-1.57.271-1.614.931h0v-.888Z",
    transform: "translate(-397.196 -134.173)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15159",
    "data-name": "Path 15159",
    d: "M187.215,156.274H188.7a1.808,1.808,0,0,0-2-1.906,2,2,0,0,0-2.231,2.1c0,1.451,1.527,1.657,1.776,1.722.3.086,1.137.184,1.137,1.1,0,.347-.412.433-.769.433a.7.7,0,0,1-.7-.671h-1.657a2.111,2.111,0,0,0,2.361,2.122,2.282,2.282,0,0,0,2.307-2.1,2.158,2.158,0,0,0-1.971-1.917c-1.31-.184-1.18-1.321-.422-1.321.715,0,.671.314.693.433Z",
    transform: "translate(-160.035 -134.541)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15160",
    "data-name": "Path 15160",
    d: "M345.741,146.871a2.93,2.93,0,1,1-2.306-4.732,2.908,2.908,0,0,1,2.285,1.094h1.906a4.527,4.527,0,0,0-4.191-2.761,4.6,4.6,0,1,0,0,9.194,4.648,4.648,0,0,0,4.223-2.794h-1.917Z",
    transform: "translate(-291.37 -122.734)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15164",
    "data-name": "Path 15164",
    d: "M495.5,160.459a3.514,3.514,0,1,0,0-7.028v1.494a2.02,2.02,0,1,1,0,4.039Zm0,0h0v-1.495h0a2.02,2.02,0,1,1,0-4.039h0v-1.494h0a3.514,3.514,0,1,0,0,7.028Z",
    transform: "translate(-421.481 -133.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15165",
    "data-name": "Path 15165",
    d: "M408.375,160.459a3.514,3.514,0,1,0,0-7.028h0v1.494h0a2.02,2.02,0,1,1,0,4.039h0v1.495Zm0-7.028a3.514,3.514,0,1,0,0,7.028v-1.495a2.02,2.02,0,1,1,0-4.039Z",
    transform: "translate(-347.464 -133.745)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15166",
    "data-name": "Path 15166",
    d: "M256.513,158.194h3.433a2.856,2.856,0,0,0,.022-.3V157.6a3.432,3.432,0,0,0-3.454-3.519v1.635c.823,0,1.635.379,1.635,1.126h-1.635v1.354Zm0,2.837c1.364-.022,3.281-.91,3.281-2.047h-1.83c0,.271-.7.52-1.451.509Zm-1.679-2.837h1.679V156.84h-1.635c0-.747.812-1.126,1.635-1.126v-1.635h-.043a3.428,3.428,0,0,0-3.389,3.6v.065a3.188,3.188,0,0,0,3.368,3.292h.065v-1.538c-.823-.011-1.679-.347-1.679-1.3Z",
    transform: "translate(-218.515 -134.295)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15167",
    "data-name": "Path 15167",
    d: "M130.743,160.459a3.514,3.514,0,1,0,0-7.028v1.494a2.02,2.02,0,1,1,0,4.039Zm0,0h0v-1.495h0a2.02,2.02,0,1,1,0-4.039h0v-1.494h0a3.514,3.514,0,1,0,0,7.028Z",
    transform: "translate(-111.587 -133.745)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMasterCardIcon);
export default __webpack_public_path__ + "static/media/MasterCard-icon.52a628b7.svg";
export { ForwardRef as ReactComponent };